import firebase from 'firebase/app';
import 'firebase/database';
import firebaseDB from '@/assets/config/firebase';
import swal from 'sweetalert';
import { notifySlackOfActivity } from './slack';

export function logAdminActivity(activity) {
  return new Promise((resolve, reject) => {
    const userAgent = navigator.userAgent;
    const platform = navigator.platform;

    navigator.permissions.query({ name: 'geolocation' }).then(function (permissionStatus) {
      if (permissionStatus.state === 'prompt') {
        swal("Warning", "Allow the location permission in order to proceed the action", "warning");
      } else if (permissionStatus.state === 'denied') {
        reject(new Error("Location permission is denied. Please enable it in browser settings."));
        return;
      }

      navigator.geolocation.getCurrentPosition(
        function (position) {
          const fullActivity = {
            ...activity,
            browserName: userAgent,
            osName: platform,
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
            map: `https://www.google.com/maps?q=${position.coords.latitude},${position.coords.longitude}`,
          };

          adminActivities(fullActivity)
            .then(() => resolve(fullActivity))
            .catch(error => reject(error));
        },
        function (error) {
          console.error('⚠️ Geolocation error:', error.message || error);
          reject(new Error("Location permission is denied. Please enable it in browser settings.")); // Changed to new Error
        },
        {
          timeout: 15000,
          enableHighAccuracy: true,
        }
      );
    });
  });
}


async function adminActivities(activityData) {
  const originalAdminUser = localStorage.getItem('originalAdminUser') ? JSON.parse(localStorage.getItem('originalAdminUser')) : null;
  if (originalAdminUser) {
    activityData.actionUserId = originalAdminUser.uid;
    activityData.actionUsername = originalAdminUser.username;
    activityData.actionUserEmail = originalAdminUser.companyEmail;
  }
  await firebaseDB.logAdminActivityToDB(activityData);
  await notifySlackOfActivity(activityData);

  return activityData;
}

// Still used by bug reports
export function sendToTrello(cardData) {
  return new Promise((resolve, reject) => {
    const apiKey = process.env.PROD_VUE_APP_ACTIVITY_TRELLO_API_KEY;
    const apiToken = process.env.PROD_VUE_APP_ACTIVITY_TRELLO_TOKEN;

    const url = `https://api.trello.com/1/cards?key=${apiKey}&token=${apiToken}`;

    const payload = {
      name: cardData.name || 'Untitled Activity',
      desc: cardData.desc || '',
      idList: cardData.idList,
      pos: cardData.pos || 'top',
    };

    if (cardData.due) {
      payload.due = cardData.due;
    }

    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    })
      .then(response => {
        if (!response.ok) throw new Error('Trello error: ' + response.status);
        return response.json();
      })
      .then(data => {
        console.log('✅ Trello card created:', data);
        resolve(data);
      })
      .catch(error => {
        console.error('❌ Trello API error:', error);
        reject(error);
      });
  });
}

export function createActivityPayload({user, title, description, changes = null, reason = null, username = null, type = "create_user", uid = null, isAdmin = true, attendees = null}) {
  return {
    activityOnUserName: username,
    activityByUserName: user.username || "Admin",
    activityName: title,
    adminId: isAdmin ? user.uid : null,
    activityOnUser: uid,
    activityTitle: title,
    activityDescription: description,
    changes,
    reason,
    type,
    attendees,
    timestamp: new Date().toLocaleString('en-PK'), 
  };
}

export function formatValue(value) {
    if (value === null || value === undefined) return 'N/A';

    if (Array.isArray(value)) {
        return value.length ? value.map(v => formatValue(v)).join(', ') : '[]';
    }

    if (typeof value === 'object') {
        const entries = Object.entries(value);
        if (!entries.length) return '{}';
        return entries
            .map(([k, v]) => `${k}: ${formatValue(v)}`)
            .join(', ');
    }

    return value;
}



export function getUpdatedFields(oldData, newData) {
  console.log(oldData)
  console.log(newData)
    const updated = {};
    for (const key in newData) {
        const oldValue = oldData ? oldData[key] : undefined;
        const newValue = newData ? newData[key] : undefined;

        const oldStr = typeof oldValue === 'object' ? JSON.stringify(oldValue) : oldValue;
        const newStr = typeof newValue === 'object' ? JSON.stringify(newValue) : newValue;

        if (oldStr !== newStr) {
            updated[key] = { old: oldValue, new: newValue };
        }
    }
    return updated;
}



// WEBPACK FOOTER //
// ./src/utils/adminLogs.js